function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Layer from "./..";
import { ClassicLayerSailNextContext } from '@sail/global-state';
import * as React from 'react';
import Rect from "../Rect";
import classNames from 'clsx';
import calculateAutoflip from "./calculateAutoflip";
import calculateContextPoint from "./calculateContextPoint";
import elementContains from "../elementContains";
import getViewportHeight from "../getViewportHeight";
import getViewportWidth from "../getViewportWidth";
import ContextualLayerStyleOverride from "./ContextualLayerStyleOverride";
function hasAncestor(el, cls) {
  let element = el;
  while (element && !element.classList.contains(cls)) {
    // @ts-expect-error - TS2322 - Type 'HTMLElement | null' is not assignable to type 'Element'.
    element = element.parentElement;
  }
  return !!element;
}
class ContextualLayer extends React.Component {
  constructor(props) {
    super(props);
    this.ref = void 0;
    this.childRef = node => {
      this.ref = node;
    };
    /**
     * If a scroll event occurs on a target element that contains the context
     * element, allow the caller to handle the event, e.g. to hide the layer.
     * If no handler is specified or the event is not handled by the caller,
     * the default behavior is to reposition the layer.
     */
    this.handleScroll = e => {
      const {
        target
      } = e;
      const {
        context,
        onScroll
      } = this.props;
      const {
        element
      } = context;
      if (target instanceof Node && elementContains(target, element) && (!onScroll || onScroll(e) !== 'handled')) {
        requestAnimationFrame(() => this.calculate());
      }
    };
    this.handleResizeWindow = e => {
      const {
        onResizeWindow
      } = this.props;
      // @ts-expect-error - TS2367 - This condition will always return 'true' since the types 'boolean' and 'string' have no overlap.
      if (!onResizeWindow || !onResizeWindow(e) !== 'handled') {
        requestAnimationFrame(() => this.calculate());
      }
    };
    this.state = {
      childStyle: null,
      contextPoint: null,
      meetingPointClasses: this.getMeetingPointClasses(props.contextMeetingPoint, props.layerMeetingPoint)
    };
  }
  componentDidMount() {
    this.calculate();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.children !== this.props.children || prevProps.context.element !== this.props.context.element || prevProps.context.rect !== this.props.context.rect || prevProps.contextMeetingPoint !== this.props.contextMeetingPoint || prevProps.layerMeetingPoint !== this.props.layerMeetingPoint || prevProps.offsetX !== this.props.offsetX || prevProps.offsetY !== this.props.offsetY) {
      this.calculate();
    }
  }
  get isNewSailClassicLayers() {
    return !!this.context;
  }
  calculate() {
    const node = this.ref;
    if (!node) {
      return;
    }
    const {
      adjustOffsets,
      adjustMeetingPoints,
      autoflip,
      context,
      flipAxis,
      offsetX: givenOffsetX,
      offsetY: givenOffsetY,
      onCalculate,
      variableWidth
    } = this.props;
    let {
      contextMeetingPoint,
      layerMeetingPoint
    } = this.props;
    let offsetX = givenOffsetX || 0;
    let offsetY = givenOffsetY || 0;
    const layerRect = Rect.fromClientRect(node.getBoundingClientRect(), 'document');
    const {
      element,
      rect
    } = context;
    const contextClientRect = rect || element.getBoundingClientRect();
    if (autoflip && autoflip !== 'none') {
      const autoflipBehavior = typeof autoflip === 'boolean' ? 'both' : autoflip;
      const {
        contextMeetingPoint: flippedContextPoint,
        layerMeetingPoint: flippedLayerPoint
      } = calculateAutoflip({
        autoflipBehavior,
        contextClientRect,
        contextMeetingPoint,
        flipAxis: flipAxis || 'context-center',
        // Flow types for these props aren't great
        layerRect,
        layerMeetingPoint,
        offsetY,
        offsetX
      });
      contextMeetingPoint = flippedContextPoint;
      layerMeetingPoint = flippedLayerPoint;
    }
    if (adjustMeetingPoints) {
      const adjusted = adjustMeetingPoints(contextMeetingPoint, layerMeetingPoint);
      contextMeetingPoint = adjusted.context;
      layerMeetingPoint = adjusted.layer;
    }
    if (adjustOffsets) {
      const adjusted = adjustOffsets(contextMeetingPoint, layerMeetingPoint, offsetX, offsetY);
      offsetX = adjusted.x;
      offsetY = adjusted.y;
    }
    const contextRect = Rect.fromClientRect(contextClientRect, 'document');
    const contextPoint = calculateContextPoint({
      contextRect,
      contextMeetingPoint,
      layerRect,
      layerMeetingPoint,
      offsetX,
      offsetY
    });
    this.setState({
      childStyle: this.childStyle(layerMeetingPoint, contextPoint, layerRect, variableWidth),
      contextPoint,
      meetingPointClasses: this.getMeetingPointClasses(contextMeetingPoint, layerMeetingPoint)
    }, () => {
      const {
        contextPoint
      } = this.state;
      // trigger an event with the offsets and size of the layer
      if (onCalculate && contextPoint) {
        // get the top and left offsets of the contextPoint of the layer
        const {
          y: top,
          x: left
        } = contextPoint;
        // get the dimensions of the layer
        const {
          width,
          height
        } = layerRect;
        // Adding all the properties necessary for a Rect
        onCalculate(new Rect({
          top,
          left,
          right: left + width,
          bottom: top + height,
          width,
          height
        }, 'document'));
      }
    });
  }
  getMeetingPointClasses(contextMeetingPoint, layerMeetingPoint) {
    return classNames({
      'ContextualLayer-layer--topleft': layerMeetingPoint === 'topleft',
      'ContextualLayer-layer--top': layerMeetingPoint === 'top',
      'ContextualLayer-layer--topright': layerMeetingPoint === 'topright',
      'ContextualLayer-layer--anytop': layerMeetingPoint.includes('top'),
      'ContextualLayer-layer--right': layerMeetingPoint === 'right',
      'ContextualLayer-layer--anyright': layerMeetingPoint.includes('right'),
      'ContextualLayer-layer--bottomright': layerMeetingPoint === 'bottomright',
      'ContextualLayer-layer--bottom': layerMeetingPoint === 'bottom',
      'ContextualLayer-layer--bottomleft': layerMeetingPoint === 'bottomleft',
      'ContextualLayer-layer--anybottom': layerMeetingPoint.includes('bottom'),
      'ContextualLayer-layer--left': layerMeetingPoint === 'left',
      'ContextualLayer-layer--anyleft': layerMeetingPoint.includes('left'),
      'ContextualLayer-layer--center': layerMeetingPoint === 'center',
      'ContextualLayer-context--topleft': contextMeetingPoint === 'topleft',
      'ContextualLayer-context--top': contextMeetingPoint === 'top',
      'ContextualLayer-context--topright': contextMeetingPoint === 'topright',
      'ContextualLayer-context--anytop': contextMeetingPoint.includes('top'),
      'ContextualLayer-context--right': contextMeetingPoint === 'right',
      'ContextualLayer-context--anyright': contextMeetingPoint.includes('right'),
      'ContextualLayer-context--bottomright': contextMeetingPoint === 'bottomright',
      'ContextualLayer-context--bottom': contextMeetingPoint === 'bottom',
      'ContextualLayer-context--bottomleft': contextMeetingPoint === 'bottomleft',
      'ContextualLayer-context--anybottom': contextMeetingPoint.includes('bottom'),
      'ContextualLayer-context--left': contextMeetingPoint === 'left',
      'ContextualLayer-context--anyleft': contextMeetingPoint.includes('left'),
      'ContextualLayer-context--center': contextMeetingPoint === 'center'
    });
  }
  childStyle(layerMeetingPoint, contextPoint, layerRect, variableWidth) {
    const width = variableWidth ? 'auto' : `${layerRect.width}px`;
    if (!contextPoint) {
      return {
        bottom: 'auto',
        left: '0px',
        right: 'auto',
        top: '0px',
        width
      };
    }
    const {
      x,
      y
    } = contextPoint;
    let bottom = 'auto';
    let left = `${x}px`;
    let right = 'auto';
    let top = `${y}px`;
    if (this.isNewSailClassicLayers) {
      if (/bottom/.test(layerMeetingPoint)) {
        top = `${y - layerRect.height}px`;
      }
      if (/right/.test(layerMeetingPoint)) {
        left = `${x - layerRect.width}px`;
      }
      return {
        top,
        left,
        width
      };
    }
    if (/bottom/.test(layerMeetingPoint)) {
      top = 'auto';
      bottom = `${getViewportHeight() - y}px`;
    }
    if (/right/.test(layerMeetingPoint)) {
      left = 'auto';
      right = `${getViewportWidth() - x}px`;
    }
    return {
      bottom,
      left,
      right,
      top,
      width
    };
  }
  render() {
    const {
      children,
      context,
      layerClassName,
      onClickOutside,
      onMouseEnter,
      onMouseLeave,
      pointerEvents,
      contained,
      trapFocus,
      returnFocus,
      variableWidth
    } = this.props;
    const {
      childStyle,
      contextPoint,
      meetingPointClasses
    } = this.state;
    const modalContentsEl = hasAncestor(context.element, 'ModalLayer-contents');
    const className = classNames(meetingPointClasses, {
      'ContextualLayer-container': true,
      'ContextualLayer--hidden': !contextPoint,
      'ContextualLayer--pointerEvents': pointerEvents,
      'ContextualLayer--inModal': modalContentsEl,
      'ContextualLayer--contained': contained
    }, layerClassName);
    return /*#__PURE__*/React.createElement(ContextualLayerStyleOverride.Consumer, null, ({
      styleOverride
    }) => /*#__PURE__*/React.createElement(Layer, {
      onClickOutside: onClickOutside,
      onScroll: this.handleScroll,
      onResizeWindow: this.handleResizeWindow,
      trapFocus: contextPoint && !variableWidth ? trapFocus : false,
      returnFocus: returnFocus
    }, /*#__PURE__*/React.createElement("div", {
      className: className,
      ref: this.childRef,
      style: _objectSpread(_objectSpread({}, childStyle), styleOverride)
      // @ts-expect-error - TS2322 - Type '((event: MouseEvent<Element, MouseEvent>) => void) | null | undefined' is not assignable to type 'MouseEventHandler<HTMLDivElement> | undefined'.
      ,
      onMouseEnter: onMouseEnter
      // @ts-expect-error - TS2322 - Type '((event: MouseEvent<Element, MouseEvent>) => void) | null | undefined' is not assignable to type 'MouseEventHandler<HTMLDivElement> | undefined'.
      ,
      onMouseLeave: onMouseLeave
    }, children)));
  }
}
ContextualLayer.defaultProps = {
  autoflip: false,
  flipAxis: 'context-center',
  layerClassName: '',
  offsetX: 0,
  offsetY: 0,
  pointerEvents: true,
  variableWidth: false
};
ContextualLayer.contextType = ClassicLayerSailNextContext;
export default ContextualLayer;